export default __webpack_public_path__ + "static/media/part_logo1.b1fa7ff3.png";